import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Wrench, ArrowUpRight } from 'lucide-react';

/**
 * Onboarding card shown to platform administrators on the tenant selector
 * screen. Clicking it opens the dedicated Admin SPA in a new tab.
 *
 * Renders nothing when `href` is empty so SPAs that have not configured
 * `VITE_REACT_ADMIN_ROUTE` silently omit the card.
 */
export default function AdminDashboardCard({ href }) {
  const { t } = useTranslation();

  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="group mt-auto block w-full rounded-lg border-2 border-primary-500/70 bg-white p-6 shadow-sm transition hover:border-primary-600 hover:shadow-md dark:border-primary-400/60 dark:bg-dark-800 dark:hover:border-primary-300"
    >
      <div className="flex items-start gap-4">
        <div className="rounded-full bg-primary-100 p-3 dark:bg-primary-500/20">
          <Wrench className="size-6 text-primary-600 dark:text-primary-300" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-dark-100">
            {t('adminTenantSelector.adminCard.title')}
          </h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-dark-300">
            {t('adminTenantSelector.adminCard.description')}
          </p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition group-hover:gap-2 dark:text-primary-300">
            {t('adminTenantSelector.adminCard.cta')}
            <ArrowUpRight className="size-4" />
          </span>
        </div>
      </div>
    </a>
  );
}

AdminDashboardCard.propTypes = {
  href: PropTypes.string,
};
